import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import type { TransferFlowState } from '../flowConfig';
import type { Vehicle } from '../../../api/types/transfer';

export function TransferResultsStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const vehicles = flow.state.searchResult?.vehicles ?? [];

  const handleSelect = (vehicle: Vehicle) => {
    flow.runStep({ selectedVehicle: vehicle });
  };

  if (vehicles.length === 0) {
    return (
      <Typography color="text.secondary">
        Sonuç bulunamadı. Lütfen arama kriterlerini değiştirip tekrar deneyin.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">Uygun Araçlar</Typography>
      {vehicles.map((vehicle) => (
        <Card key={vehicle.productId} variant="outlined">
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                <Typography variant="subtitle1">{vehicle.title ?? vehicle.name}</Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                  {vehicle.maxPax && <Chip size="small" label={`Maks. yolcu: ${vehicle.maxPax}`} />}
                  {vehicle.maxSuitcase && <Chip size="small" label={vehicle.maxSuitcase} />}
                  {vehicle.provider && <Chip size="small" label={vehicle.provider} />}
                  {vehicle.freeCancelHourBefore && (
                    <Chip size="small" label={`Ücretsiz iptal: ${vehicle.freeCancelHourBefore} sa. öncesine kadar`} />
                  )}
                  {vehicle.isOutBudget && (
                    <Chip
                      size="small"
                      color="warning"
                      label={
                        vehicle.maxBudget
                          ? `Kural Dışı Fiyat (bütçe: ${vehicle.maxBudget.toLocaleString('tr-TR')} TL)`
                          : 'Kural Dışı Fiyat'
                      }
                    />
                  )}
                </Stack>
              </Box>
              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="h6">
                  {vehicle.priceDetails?.displayPrice?.toLocaleString('tr-TR')}{' '}
                </Typography>
                <Button
                  variant="contained"
                  color={vehicle.isOutBudget ? 'warning' : 'primary'}
                  disabled={flow.status === 'running'}
                  onClick={() => handleSelect(vehicle)}
                >
                  {vehicle.isOutBudget ? 'Onaya Gönder' : 'Seç'}
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}
